const Search = {
  init: () => {
    const searchInputEl = document.querySelector("#search-field");

    if (searchInputEl) {
      searchInputEl.addEventListener("keyup", (e) => {
        if (e.keyCode === 13) {
          document.location = `?s=${searchInputEl.value}`;
        }
      });
    }
  },
};

export default Search;
